import { render, staticRenderFns } from "./product-type.vue?vue&type=template&id=ba4d9004&scoped=true&"
import script from "./product-type.vue?vue&type=script&lang=js&"
export * from "./product-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d9004",
  null
  
)

export default component.exports